export default "__VITE_ASSET__DR9cpteg__"